import React, { forwardRef, useMemo } from 'react';
import classNames from 'classnames';
import Loader from 'components/Loaders/Loader/Loader';
import styles from './Button.module.scss';

export type ButtonVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'tertiary-primary'
  | 'tertiary-danger'
  | 'outline-danger'
  | 'danger'
  | 'link'
  | 'link-underline'
  | 'link-gray'
  | 'dropdownItem'
  | 'dropdownItem-danger'
  | 'group';

export type ButtonSize = 'sm' | 'md' | 'lg' | 'xl';

export interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  loading?: boolean;
  size?: ButtonSize
  prefixIcon?: React.ReactNode;
  suffixIcon?: React.ReactNode;
}

const Button = forwardRef<HTMLButtonElement, IButtonProps>(({
  children,
  variant = 'primary',
  className,
  type = 'button',
  size = 'md',
  disabled,
  prefixIcon,
  suffixIcon,
  loading = false,
  ...props
}, ref) => {
  const variantClass = useMemo<string>(() => styles[`btn-${variant}`], [variant]);

  const sizeClass = useMemo<string>(() => styles[`btn-${size}`], [size]);

  return (
    <button
      ref={ref}
      className={classNames(className, styles.btn, variantClass, sizeClass, {
        [styles.loading]: loading,
      })}
      // eslint-disable-next-line react/button-has-type
      type={type}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? <Loader className={styles.loader} /> : prefixIcon}
      {children && <span>{children}</span>}
      {suffixIcon}
    </button>
  );
});
export default Button;
